import { ConversationMessage } from "../../types/Messaging/Message";
import { Box, Paper, Rating, Stack, Typography } from "@mui/material";
import caseMessageStyle from "./caseMessageStyle";
import React from "react";
import MessageUserReadStatus from "../../types/Messaging/MessageUserReadStatus";
import DisplayableMediaObjects from "../MediaObject/DisplayableMediaObjects";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { userHasRole } from "../../services/backofficeUserService";
import { Roles } from "../../types/BackofficeUser";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

const StyledRating = styled(Rating)(({ theme }) => ({
  "&.Mui-disabled": {
    opacity: 1,
    paddingBottom: "1px",
  },
  "& .MuiSvgIcon-root": {
    width: "14px",
    height: "14px",
  },
  "& .MuiRating-iconFilled": {
    color: theme.palette.text.secondary,
  },
  "&. MuiRating-iconEmpty": {
    color: theme.palette.text.primary,
  },
}));

function CaseMessage({ message }: { message: ConversationMessage }) {
  const isCustomerMessage = message.senderType === "customer";
  const customerReadTime = message.userReadStatus.find(
    (status: MessageUserReadStatus) => status.messagingUser?.messagingUserType === "customer"
  )?.created;

  const currentUser = useCurrentUser();
  const isExternal = userHasRole(currentUser, Roles.external);

  return (
    <>
      <Box
        sx={{
          ...caseMessageStyle.messageContainer,
          ...(isCustomerMessage ? caseMessageStyle.otherMessageContainer : caseMessageStyle.ownMessageContainer),
        }}
      >
        <Paper
          elevation={0}
          sx={{
            ...caseMessageStyle.messageBubble,
            ...(isCustomerMessage ? caseMessageStyle.otherMessageBubble : caseMessageStyle.ownMessageBubble),
          }}
        >
          <Stack direction={"row"} sx={{
            justifyContent: "space-between"
          }}>
            <Typography sx={{
              fontWeight: "bold"
            }}>
              {message.senderType === "system" ? "Legalbird" : message.sender.messagingUserFullName}
            </Typography>
            <Stack>
              <Typography>{dayjs(message.created).format("DD.MM.YYYY, HH:mm") + " Uhr"}</Typography>
              {!isExternal && message.customerFeedback && (
                <Stack direction={"row"} sx={{
                  alignItems: "center"
                }}>
                  <Typography>Bewertung:</Typography>
                  <StyledRating defaultValue={message.customerFeedback.stars} disabled />
                </Stack>
              )}
            </Stack>
          </Stack>
          <Box
            sx={{ overflowWrap: "anywhere", margin: "2rem 0" }}
            dangerouslySetInnerHTML={{ __html: message.messageText }}
          />
          {message.attachments && <DisplayableMediaObjects mediaObjects={message.attachments} loadDisplayUrl />}
        </Paper>
        {!isCustomerMessage && customerReadTime && (
          <>
            <Box sx={caseMessageStyle.readBox}>
              <Typography>Gelesen: {dayjs(customerReadTime).format("DD.MM.YYYY, HH:mm") + " Uhr"}</Typography>
            </Box>
          </>
        )}
      </Box>
    </>
  );
}

export default CaseMessage;
